import { render, staticRenderFns } from "./DeleteProductModal.vue?vue&type=template&id=5027b6f9&scoped=true"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteProductModal.vue?vue&type=style&index=0&id=5027b6f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5027b6f9",
  null
  
)

export default component.exports